import { Controller } from "@hotwired/stimulus"

// Raccourcis de saisie pour les dates de début/fin d'une vente flash :
// évite de jongler avec le picker natif (pénible sur mobile) pour les cas
// les plus courants ("ce soir", "+24h"...).
export default class extends Controller {
  static targets = ["starts", "ends"]

  toLocalInputValue(date) {
    const pad = (n) => String(n).padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
  }

  // "Maintenant"
  startNow(event) {
    event.preventDefault()
    this.startsTarget.value = this.toLocalInputValue(new Date())
    this.startsTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // "Ce soir 20h" (demain 20h si 20h est déjà passé aujourd'hui)
  startTonight(event) {
    event.preventDefault()
    const now = new Date()
    const tonight = new Date(now)
    tonight.setHours(20, 0, 0, 0)
    if (tonight <= now) tonight.setDate(tonight.getDate() + 1)
    this.startsTarget.value = this.toLocalInputValue(tonight)
    this.startsTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // Boutons "+24h" / "+48h" / "+72h" : durée à partir du début déjà saisi
  setDuration(event) {
    event.preventDefault()
    const hours = parseInt(event.currentTarget.dataset.hours, 10)
    const startValue = this.startsTarget.value
    const start = startValue ? new Date(startValue) : new Date()
    if (!startValue) this.startsTarget.value = this.toLocalInputValue(start)

    const end = new Date(start.getTime() + hours * 60 * 60 * 1000)
    this.endsTarget.value = this.toLocalInputValue(end)
    this.endsTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
